import {
  map,
  startWith,
  switchMap,
  catchError,
  debounceTime,
} from 'rxjs/operators';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { EMPTY, merge, Subject } from 'rxjs';
import { SubSink } from 'subsink';
import { MatInput } from '@angular/material/input';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { FormControl, FormGroup } from '@angular/forms';
import { UserService, UserSocket } from 'src/app/core';

@Component({
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss'],
})
export class AdminUsersComponent implements OnInit {
  @ViewChild(MatDateRangePicker) dateRangePicker!: MatDateRangePicker<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  @ViewChild('search') searchInput!: MatInput;
  @ViewChild(MatSort) sort!: MatSort;

  public startDate: string = '';
  public endDate: string = '';

  rangeFormGroup = new FormGroup({
    startDate: new FormControl(),
    endDate: new FormControl(),
  });

  public searchController$ = new Subject<
    { searchString: string } | undefined
  >();
  public refreshController$ = new Subject();
  public dateController$ = new Subject();

  public isRateLimitReached: boolean = false;
  public isLoadingResult: boolean = false;
  public resultsLength: number = 0;

  public dataSource = new MatTableDataSource<any>();
  public displayedColumns: string[] = [
    'user_id',
    'user_avatar',
    'user_fullName',
    'totalvalue',
    'totalsharedfiles',
    'totalScore',
    'actions',
  ];

  range = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
  });

  // ------------------------------------------------Private methods|

  private subsink = new SubSink();

  // ------------------------------------------------Constructor|

  constructor(
    private userService: UserService,
    private userSocket: UserSocket,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.subsink.sink = merge(
      this.paginator.page,
      this.sort.sortChange,
      this.dateController$,
      this.refreshController$,
      this.searchController$.pipe(debounceTime(350)),
      this.userSocket.onConnect$()
    )
      .pipe(
        startWith({}),
        switchMap((value: any, index: any) => {
          this.isLoadingResult = true; // Start loading
          this.cdr.detectChanges();
          const search =
            value && 'searchString' in value
              ? value['searchString']
              : undefined;

          const order = value?.direction
            ? value.direction.toUpperCase()
            : undefined;

          const range = this.range.value;

          return this.userService
            .getUsersList({
              page: this.paginator.pageIndex + 1,
              limit: this.paginator.pageSize,
              orderTarget: order && value?.active ? value.active : undefined,
              order,
              search,
              startDate: range?.start
                ? new Date(range.start).toISOString()
                : undefined,

              endDate: range?.end
                ? new Date(range.end).toISOString()
                : undefined,
            })
            .pipe(catchError(() => EMPTY));
        }),
        map((data) => {
          this.isLoadingResult = false;
          this.isRateLimitReached = data.items.length === 0;
          this.cdr.detectChanges();

          if (this.isRateLimitReached) {
            return [];
          }

          this.resultsLength = data.meta.totalItems + 1;
          return data.items;
        })
      )
      .subscribe((data) => {
        this.dataSource = new MatTableDataSource(data);
      });
  }
}
